<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Wallets</h4>
        <div class="text-muted small">Your currency balances and wallet settings</div>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="refresh()">
          <span *ngIf="!loading">Refresh</span>
          <span *ngIf="loading">Refreshing...</span>
        </button>

        <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#createWalletModal">
          Create new wallet
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="card shadow-sm border-0">
      <div class="card-body p-4">
        <div class="placeholder-glow">
          <div class="placeholder col-12 mb-2"></div>
          <div class="placeholder col-12 mb-2"></div>
          <div class="placeholder col-10 mb-2"></div>
          <div class="placeholder col-8"></div>
        </div>
      </div>
    </div>

    <div *ngIf="error && !loading" class="alert alert-danger">
      {{ error }}
    </div>

    <div *ngIf="!loading && !error && !wallets.length" class="card shadow-sm border-0">
      <div class="card-body p-4 text-center">
        <div class="fw-semibold mb-1">No wallets yet</div>
        <div class="text-muted small mb-3">Create a wallet to start depositing, withdrawing, and trading.</div>
        <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#createWalletModal">
          Create new wallet
        </button>
      </div>
    </div>

    <div *ngIf="!loading && wallets.length" class="row g-3 mb-4">
      <div class="col-12 col-md-6 col-xl-4" *ngFor="let w of wallets">
        <div class="card wallet-card border-0 h-100">
          <div class="card-body p-3">
            <div class="d-flex align-items-start justify-content-between">
              <div>
                <div class="small text-muted fw-semibold">{{ w.currency.code }}</div>
                <a class="fw-bold text-decoration-none" [routerLink]="['/wallets/manage', w.walletId]">
                  {{ w.currency.name }}
                </a>
              </div>
              <span class="badge text-bg-success-subtle border border-success-subtle text-success">
                {{ w.status }}
              </span>
            </div>

            <div class="py-3">
              <div class="text-muted small mb-1">Available Balance</div>
              <div class="fs-4 fw-bold">
                {{ w.availableBalance | smartAmount:w.currency.symbol }}
              </div>
              <div class="text-muted small">
                Current balance: {{ w.balance | smartAmount:w.currency.symbol }}
              </div>
            </div>

            <div class="d-flex flex-wrap gap-2">
              <a [routerLink]="['/wallets/manage', w.walletId]" class="btn btn-outline-primary btn-sm">
                Manage
              </a>
              <a [routerLink]="['/wallets/deposit', w.walletId]" class="btn btn-outline-secondary btn-sm">
                Deposit
              </a>
              <a [routerLink]="['/wallets/withdraw', w.walletId]" class="btn btn-outline-secondary btn-sm">
                Withdraw
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>

<div class="modal fade" id="createWalletModal" tabindex="-1" aria-labelledby="createWalletModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title fw-semibold" id="createWalletModalLabel">Create Wallet</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <form [formGroup]="createWalletForm" (ngSubmit)="createWallet()">
        <div class="modal-body">
          <div class="text-muted small mb-3">
            Choose the currency you want to create a wallet for.
          </div>

          <div class="mb-3">
            <label class="form-label small text-muted mb-1">Currency</label>
            <select class="form-select" formControlName="currency">
              <option value="" disabled>
                {{ loadingCurrencies ? 'Loading currencies...' : 'Select currency' }}
              </option>
              <option *ngFor="let c of currencies" [value]="c.currencyCode">
                {{ c.currencyCode }} - {{ c.currencyName }}
              </option>
            </select>

            <div class="text-danger small mt-1" *ngIf="submittedWallet && createWalletForm.invalid">
              Please select a currency.
            </div>
          </div>

          <div class="alert alert-warning py-2 mb-0" *ngIf="walletExistsWarning">
            <div class="fw-semibold">Wallet already exists</div>
            <div class="small">You already have a {{ walletExistsWarning }} wallet.</div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
            [disabled]="creatingWallet">
            Cancel
          </button>

          <button type="submit" class="btn btn-primary"
            [disabled]="creatingWallet || createWalletForm.invalid || !!walletExistsWarning">
            <span *ngIf="creatingWallet" class="spinner-border spinner-border-sm me-2"></span>
            Create
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
